export default __webpack_public_path__ + "static/media/WhatsApp Image 2023-08-08 at 20.09.19.8f828aab.jpeg";